import { useState, useEffect } from "react";
import { gql, useQuery, useLazyQuery, useMutation } from "@apollo/client";
import { IProject } from "../../../types/project";
import { SettingContainer } from "../../../commonStyles";
import { Typography, Autocomplete, TextField, Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { selectProject } from "../../../features/project/projectSlice";
import { IEmailTemplate } from "../../../types/process";
import { selectCrmProjectId, selectLeadTemplate } from "../../../features/projectSetting/projectSettingSlice";
import { useAppDispatch } from "../../../app/hooks";
import { showSuccessSnackbar } from "../../../features/snackbar/snackbarSlice";

const Email = (props: ChildProps) => {
  const storeDispatch = useAppDispatch();
  const project = useSelector(selectProject);
  const crmProjectId = useSelector(selectCrmProjectId);
  const crmLeadTemplate = useSelector(selectLeadTemplate);
  const [newLeadEmail, setNewLeadEmail] = useState<IEmailTemplate | null>(crmLeadTemplate ? crmLeadTemplate : null)

  const [updateCrmProject] = useMutation(UPDATECRMPROJECT, {
    onCompleted: (data) => {
      storeDispatch(showSuccessSnackbar("Project Successfully Updated!"));
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const { data } = useQuery(GETEMAILTEMPLATES, {
    variables: {
      filter: {
        archived: false,
        project: project?._id,
      },
    },
    onCompleted: (data) => {
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const saveEmailSettings = () => {
    updateCrmProject({
      variables: {
        _id: crmProjectId,
        record: {
          leadTemplate: newLeadEmail?._id
        },
      },
    });
  }

  return (
    <SettingContainer>
      <Typography variant="h5">
        <strong>Auto Email Templates</strong>
      </Typography>
      {data ? 
      <Box sx={{ mt : 2 }}>
        <Autocomplete
          id="registrant-sign-up-email"
          options={data.emailTemplateMany}
          freeSolo={false}
          value={newLeadEmail}
          getOptionLabel={(option: any) => option.name}
          onChange={(e, value) => setNewLeadEmail(value)}
          renderInput={(params) => <TextField {...params} variant="outlined" label="New Lead Registrant Email" />}
        />
      </Box>
      : null}
      <Button sx={{ mt: 2 }} variant="contained" onClick={() => saveEmailSettings()} color="success">
        Save
      </Button>
    </SettingContainer>
  );
};

interface ChildProps {
  project: IProject | null;
}

const GETEMAILTEMPLATES = gql`
  query emailTemplateMany($filter: FilterFindManyEmailTemplateInput) {
    emailTemplateMany(filter: $filter, limit: 10000) {
      _id
      name
    }
  }
`;

const UPDATECRMPROJECT = gql`
  mutation crmProjectSettingUpdateById($_id: MongoID!, $record: UpdateByIdCrmProjectSettingInput!) {
    crmProjectSettingUpdateById(_id: $_id, record: $record) {
      record {
        _id
        shortTermUsers {
          _id
          fullName
        }
        shortTermRealtorWalkIn {
          _id
          fullName
        }
        shortTermNoRealtorWalkIn {
          _id
          fullName
        }
        shortTermHasRealtorWalkIn {
          _id
          fullName
        }
        sales {
          _id
          firstName
          lastName
          fullName
        }
        online {
          _id
          firstName
          lastName
          fullName
        }
        scrum {
          _id
          firstName
          lastName
          fullName
        }
        smsDuringHours {
          _id
          firstName
          lastName
          fullName
        }
        smsBeforeHours {
          _id
          firstName
          lastName
          fullName
        }
        smsAfterHours {
          _id
          firstName
          lastName
          fullName
        }
        reportUsers {
          _id
          firstName
          lastName
          fullName
        }
        notificationUsers {
          _id
          firstName
          lastName
          fullName
        }
        admins {
          _id
          firstName
          lastName
          fullName
        }
        leadTemplate {
          _id
          name
        }
        displayReport
        tags
      }
    }
  }
`;

export default Email;
